ats.makeTextEditor = function (element, onUpdateCallback = null) {
    if (typeof ck_editor === 'undefined') {
        let ck_editor;
    }
    if($(element).length > 0){
        ClassicEditor.create( document.querySelector( element ),{
            toolbar: ['heading', '|', 'bold', 'italic' ,'link','|', 'indent','outdent','|', 'bulletedList', 'numberedList', 'blockQuote','|', 'insertTable' ], //'underline',
            heading: {
                options: [
                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' }
                ]
            }
        } ).then( editor => {
            ck_editor = editor; // Save for later use.

            // Store the editor instance for later use, scoped by element ID
            ats.ckEditors = ats.ckEditors || {}; // Create a storage object if not already present
            ats.ckEditors[element] = editor;

            // Flag changes on key events (e.g., to indicate editing state)
            editor.editing.view.document.on('keydown', () => {
                ats.emailIsEdited = true;
            });

            editor.editing.view.document.on('keyup', (evt, data) => {
                document.querySelector(element).value = editor.getData();
            });

            // Sync the textarea and allow external updates on data changes
            editor.model.document.on('change:data', () => {
                const editorContent = editor.getData(); // Get updated content
                document.querySelector(element).value = editorContent; // Update the textarea

                // Call the external update callback if provided
                if (typeof onUpdateCallback === 'function') {
                    onUpdateCallback(editorContent);
                }
            });
        } )
        .catch( error => {
            console.error(`Error initializing CKEditor for ${element}:`, error);
        } );
    }else{
        console.log(`Cannot create text editor: ${element} does not exist.`);
    }
}
